// Global
import React from 'react';
// Local
import { Content } from '@generated/Content/ContentBlock.model';
import { ContentBlock } from './ContentBlock';
import RichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { getComponentCss } from 'lib/utils/sitecore/component-css';

type ContentBlockProps = Content.ContentBlock.ContentBlock_Component;

export const Default = (props: ContentBlockProps) => {
  /*
   * Rendering
   */

  if (!props.fields) {
    return <></>;
  }

  return (
    <ContentBlock
      text={<RichTextWrapper field={props.fields?.contentBlockText} />}
      className={getComponentCss(props)}
    />
  );
};
